import React from 'react';

function ArrowBackIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_4091_34029)">
        <path
          fill="#374957"
          d="M4.943 5.606L1.024 9.525a3.585 3.585 0 000 4.95l3.919 3.919a1.5 1.5 0 102.121-2.121l-2.779-2.781 18.25-.023a1.5 1.5 0 100-3L4.3 10.492l2.764-2.765a1.5 1.5 0 00-2.121-2.121z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4091_34029">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ArrowBackIcon;
